import { api } from './api'

export const paymentsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        cashPayment: builder.mutation({
            query(data) {
                return {
                    url: 'payment/cash-payment',
                    method: 'POST',
                    body: data,
                }
            },
        }),
        getHostedTokenizationUrl: builder.query({
            query: () => 'payment/worldline-hosted-tokenization',
        }),
        createHostedTokenizationPayment: builder.mutation({
            query(data) {
                return {
                    url: 'payment/worldline-hosted-tokenization/create-payment',
                    method: 'POST',
                    body: data,
                }
            },
        }),
    }),
})

export const {
    useCashPaymentMutation,
    useGetHostedTokenizationUrlQuery,
    useCreateHostedTokenizationPaymentMutation,
} = paymentsApi
